<template>
  <v-card elevation="1" style="width: 100%" flat tile>
    <v-card-actions>
      <h3 class="pl-4 subtitle-2">{{title}}</h3>
      <v-spacer />
      <div><v-switch v-model="active" class="mt-0 toggle"></v-switch></div>
    </v-card-actions>
    <v-divider />
  </v-card>
</template>

<script>
export default {
  props: {
    field: String,
    title: String,
    items: Array,
    breadcrumbTitle: Boolean,
    type: String
  },
  data: () => ({
    active: false,
    mounted: false
  }),
  computed: {
    value() {
      let filter = this.$store.state.filters.find(filter => filter.field === this.field);
      if(filter) return true;
      return false;
    }
  },
  watch:{
    active (val) {
      if(this.mounted) {
        if(val){
          this.$store.commit("setFilter", { id: this.type, type: this.type, field: this.field, value: val, breadcrumbs: this.breadcrumbTitle, title: this.title })
        } else {
          this.$store.commit("removeFilter", { id: this.type })
        }
      }
    },
    value (val) {
      // Set the switch to false when remove a filter from breadcrumb
      if(!val) this.active = false;
    }
  },
  created() {
    // Initialize the switch. If true or false
    let filter = this.$store.state.filters.find(filter => filter.field === this.field);
    if(filter) this.active = filter.value;
    this.$nextTick(() => {
      this.mounted = true // if we don't use this the watch to this.active will react and add the filter twice
    })
  }
};
</script>